/**
 * Opens Shop dropdown on hover for desktop (matches arkofsweden-style UX).
 * Narrow viewports keep native click behavior on <details>.
 */
(() => {
  const MQ = '(min-width: 990px)';
  const menus = document.querySelectorAll('.header.ark-header header-menu.ark-header-menu--hover');

  if (!menus.length) return;

  const mq = window.matchMedia(MQ);

  function setExpanded(details, open) {
    const summary = details.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  menus.forEach((menu) => {
    const details = menu.querySelector('details');
    if (!details) return;

    let closeTimer;

    menu.addEventListener('mouseenter', () => {
      if (!mq.matches) return;
      window.clearTimeout(closeTimer);
      details.open = true;
      setExpanded(details, true);
    });

    menu.addEventListener('mouseleave', () => {
      if (!mq.matches) return;
      closeTimer = window.setTimeout(() => {
        details.open = false;
        setExpanded(details, false);
      }, 120);
    });
  });

  mq.addEventListener('change', (e) => {
    if (e.matches) return;
    menus.forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details) return;
      details.open = false;
      setExpanded(details, false);
    });
  });
})();
